export type Region = 'USA' | 'LATAM' | 'India' | 'EMEA'

export const REGIONS: Region[] = ['USA', 'LATAM', 'India', 'EMEA']

export interface Contributor {
  id: string
  name: string
  region: Region
  isOutOfOffice?: boolean
  oooStartDate?: string // YYYY-MM-DD
  oooEndDate?: string // YYYY-MM-DD
  lastUpdated?: string // ISO timestamp
}

export interface Solution {
  id: string
  name: string
}

// Updated status meanings:
// available = Qualified and Available
// limited = Qualified not Available
// unavailable = Not Qualified
export type AvailabilityStatus = 'available' | 'limited' | 'unavailable'

// Map of contributorId -> solutionId -> status
export type AvailabilityMap = Record<string, Record<string, AvailabilityStatus>>

export interface DateAvailability {
  id: string
  startDate: string // YYYY-MM-DD
  endDate: string // YYYY-MM-DD
  status: AvailabilityStatus
}

// Map of contributorId -> solutionId -> DateAvailability[]
export type DateAvailabilityMap = Record<
  string,
  Record<string, DateAvailability[]>
>

// Experience levels
export type ExperienceLevel = 'L1' | 'L2' | 'L3' | 'L4'

export const EXPERIENCE_LEVELS: ExperienceLevel[] = ['L1', 'L2', 'L3', 'L4']

export const EXPERIENCE_LABELS: Record<ExperienceLevel, string> = {
  L1: 'Foundational',
  L2: 'Intermediate',
  L3: 'Advanced',
  L4: 'Champion',
}

// Map of contributorId -> solutionId -> ExperienceLevel
export type ExperienceLevelMap = Record<string, Record<string, ExperienceLevel>>
